import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import Checkbox from "./elements/Checkbox"

const handleize = value => {
    return value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') 
        .replace(/-+/g, '-') 
        .replace(/^-|-$/g, '') 
}

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const isColorFacet = facet.name.toLowerCase() === 'colour'
    const isSizeFacet = facet.name.toLowerCase() === 'size'

    // if(facet.name == 'colour') {
    //     console.log('Facet', facet.data.map(value => (value.selected ? value.value : '')));
    // }
    useEffect(() => {
        const isDesktop = window.matchMedia("(min-width: 768px)").matches

        if (isDesktop && !active) {
            toggleActive()
        }
    }, []) 

    // Function to handle filter toggle and scroll to top
    const handleFilterToggle = (field, value, selected) => {
        toggleProductFilter(field, value, selected)

        const productCardSwatch = document.querySelectorAll(".product-card__swatches label.color-swatch");
        const selectedOptionColour = document.querySelectorAll(".selected-option-value.colour");

        if(selected) {
            let selectedColor = value.toLowerCase().replace(/\s+/g, '-').replace('-/-', '-');

            productCardSwatch.forEach((productColorSwatch) => {
                document.querySelector('#collectionTemplate').setAttribute('data-filter-selected', selectedColor);

                if(selectedColor == productColorSwatch.getAttribute('data-color')) {
                    document.querySelector('#collectionTemplate').setAttribute('data-filter-selected', selectedColor);

                    productColorSwatch.setAttribute('aria-checked', true);
                    productColorSwatch.classList.add('active');
                }
                else {
                    productColorSwatch.setAttribute('aria-checked', false);
                    productColorSwatch.classList.remove('active');
                }
            });

            selectedOptionColour.forEach((selectedValue) => {
                selectedValue.html(selectedColor);
            });
        } 

        // Scroll to top
        // window.scrollTo({ top: 0, behavior: 'smooth' }) 
    }

    return (
        <li className={`ns-sidebar-dropdown border-b border-solid color-border-dark ${active ? 'ns-active' : ''}`} aria-expanded={!!active}>
            <span
                id={facet.name}
                className="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand'} ${facet.name}`}
            >
                <span className="color-text text-[18px]">{facet.name}</span>
                {active ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M18 12.5H6" stroke="#191919" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M12 6.21875V12.2188M12 12.2188V18.2188M12 12.2188H18M12 12.2188L6 12.2187" stroke="#191919" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                )}
            </span>
            <div className={`ns-sidebar-submenu ${active ? '' : 'ns-d-none'}`} id={`${facet.id}-sub-menu`}>
                {isColorFacet ? (
                    <div className="ns-color-swatches grid grid-cols-4 gap-3 px-2">
                        {facet.data?.map(value => {
                            const swatchKey = handleize(value.value)
                            const swatchImage = window.plpSettings?.color_swatch_images?.[swatchKey] || ''
                            if(swatchImage) {
                                return (
                                    <label 
                                        data-color={value.value}
                                        className={`ns-swatch-option ns-d-flex ns-flex-column ns-align-items-center ns-justify-content-center cursor-pointer rounded-full ${
                                        value.selected ? '!border !border-solid !color-border-dark active' : ''
                                    }`}>
                                        <input type="checkbox" class="sr-only" value={value.value} aria-label={`${value.value} swatch`} checked={value.selected} onChange={() => handleFilterToggle(facet.field, value.value, !value.selected)} />
                                        <img
                                            src={swatchImage}
                                            alt={`${value.value} swatch`}
                                            className="ns-swatch-imag w-[36px] h-[36px] rounded-full"
                                        />
                                    </label>
                                )
                            }
                        })}
                    </div>
                ) : isSizeFacet ? (
                    <ul className="grid grid-cols-3 gap-1">
                       {facet.data
                            ?.slice() 
                            .sort((a, b) => {
                                const numA = Number(a.value)
                                const numB = Number(b.value)

                                const isNumA = !isNaN(numA)
                                const isNumB = !isNaN(numB)

                                if (isNumA && isNumB) return numA - numB
                                return a.value.localeCompare(b.value, undefined, { numeric: true, sensitivity: 'base' })
                            })
                            .map(value => (
                                <li
                                    key={value.value}
                                    className={`size-facet ${value.selected ? 'border border-solid color-border-dark' : 'not-selected'}`}
                                    data-nosto-element="facet-setting"
                                >
                                    <Checkbox
                                        value={value.value}
                                        selected={value.selected}
                                        onChange={e => {
                                            e.preventDefault()
                                            handleFilterToggle(facet.field, value.value, !value.selected) // Updated to use handleFilterToggle
                                        }}
                                    />
                                </li>
                            ))}
                    </ul>
                ) : (
                    <ul className="ns-list-unstyled ns-p-0 ns-m-0">
                        {facet.data?.map(value => (
                            <li
                                key={value.value}
                                className="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                                data-nosto-element="facet-setting"
                            >
                                <Checkbox
                                    value={value.value}
                                    selected={value.selected}
                                    onChange={e => {
                                        e.preventDefault()
                                        handleFilterToggle(facet.field, value.value, !value.selected) // Updated to use handleFilterToggle
                                    }}
                                />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </li>
    )
}